/** Copies a typed array's bytes into a plain (non-shared) ArrayBuffer for postMessage. */
export function ab(ta: { buffer: ArrayBufferLike; byteOffset: number; byteLength: number }): ArrayBuffer {
  return (ta.buffer as ArrayBuffer).slice(ta.byteOffset, ta.byteOffset + ta.byteLength);
}

/** Thin request/response wrapper around a Worker that posts {type:"progress"|"done"|"error", ...}. */
export function runWorker<TIn, TOut>(
  worker: Worker,
  payload: TIn,
  onProgress?: (stage: string) => void
): Promise<TOut> {
  return new Promise((resolve, reject) => {
    const onMessage = (e: MessageEvent) => {
      const d = e.data;
      if (d.type === "progress") {
        onProgress?.(d.stage);
        return;
      }
      worker.removeEventListener("message", onMessage);
      worker.removeEventListener("error", onError);
      if (d.type === "error") reject(new Error(d.message));
      else resolve(d as TOut);
    };
    const onError = (e: ErrorEvent) => {
      worker.removeEventListener("message", onMessage);
      worker.removeEventListener("error", onError);
      reject(new Error(e.message || "worker failed"));
    };
    worker.addEventListener("message", onMessage);
    worker.addEventListener("error", onError);
    worker.postMessage(payload as unknown as object);
  });
}
